import React, { Component } from "react";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { PersistGate } from "redux-persist/integration/react";
import { store, history, persistor } from "./services/store";
import socket from "./services/socket";
import { getUserId } from "./services/client/selectors";

import Login from "./scenes/Login";
import Dashboard from "./scenes/Dashboard/index.js";
import Settings from "./scenes/Settings";
import NotFound from "./NotFound";
import Colors from "./constants/Colors";
import moment from "moment";
import { TOKEN_REFRESH } from "./services/token/constants";

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#3A4554",
      main: Colors.main,
      dark: Colors.pureMain,
      contrastText: "#fff"
    },
    third: {
      light: Colors.main
    },
    text: {
      primary: Colors.text
    },
    background: {
      default: "#fff"
    }
  },
  typography: {
    useNextVariants: true,
    suppressDeprecationWarnings: true
    // fontFamily: "Trebuchet"
  }
});

class App extends Component {
  constructor(props) {
    super(props);
    this.socket = socket;
    this.socket.on("request-init", this.handleSocketInit);
  }

  handleSocketInit = async () => {
    const userId = await getUserId(store.getState());
    this.socket.emit("init", userId);
  };

  checkRefreshToken = async () => {
    const storeState = await store.getState();
    if (storeState.token.expiresAt) {
      const diff = moment(storeState.token.expiresAt).diff(moment(), "days");
      if (diff <= 2) {
        await store.dispatch({ type: TOKEN_REFRESH });
      }
    }
  };

  componentDidMount = async () => {
    // check if refresh token
    setTimeout(() => this.checkRefreshToken(), 2000);
    this.refreshTokenInterval = setInterval(() => {
      this.checkRefreshToken();
    }, 1000 * 60 * 60);
  };

  componentWillUnmount() {
    clearInterval(this.refreshTokenInterval);
  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <MuiThemeProvider theme={theme}>
              <Switch>
                <Route path="/login" component={Login} />
                {/* <Route path="/" component={Dashboard} /> */}
                <Route path="/" component={Dashboard} />

                {/* <Route path="/" component={Settings} /> */}
                <Route path="404" component={NotFound} />
                <Route path="*" component={NotFound} />
              </Switch>
            </MuiThemeProvider>
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
